import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import LandingPage from './assets/pages/home/home';
import TermsAndConditions from './assets/pages/terms-and-conditions/terms-and-conditions.jsx';

function App() {
  return (
    <HelmetProvider>
      <Router>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/terms-and-conditions" element={<TermsAndConditions />} />
        </Routes>
      </Router>
    </HelmetProvider>
  );
}

export default App;
